import FormInputs from "../../../../../../components/UI/FormInputs";
import { isSet } from "../../../../../../utils/commonUtils";

const RadioBoxGroup = ({
  isLabel,
  itemIndex,
  column,
  options,
  label,
  labelStyle,
  formData,
  combineToKey,
  disabled,   // 👈 NEW PROP (applies to all radio buttons)
  showContainerBorder,
  isVertical,
  layout="horizontal",
  appendElmtClass,
  name, // 👈 Group name for radio buttons
  ...props
}) => {
  // Use ?? so 0 is preserved (|| would make selectedValue "" when value is 0)
  const selectedValue = combineToKey
    ? (formData[combineToKey] ?? "")
    : (formData[name] ?? "");
  const hasContainerBorder = isSet(showContainerBorder, true);
  const radioGroupName = name || `radioGroup_${itemIndex}`;
  const isStackedLayout = layout === 'stacked';
  const selectedNorm = selectedValue === undefined || selectedValue === null ? "" : selectedValue;

  return (
    <>
      <div className={`${column} ${hasContainerBorder ? "border border-left-0" : ""} py-1`} key={itemIndex}>
        <div className={`form-group form-check form-check-solid ${isStackedLayout ? "mb-0 pl-0" : "mb-1"}`}>
          {isSet(isLabel, true) === false ? (
            <></>
          ) : (
            <label
              className="col-sm-10 f-400 text-sm text-truncate mb-0 opacity-75"
              title={label}
            >
              {label}
            </label>
          )}

          <div
            className={`${
              isSet(isLabel, true) === false ? "col-sm-12" : "col-sm-12"
            } ${isVertical ? "d-flex flex-column align-items-start" : ""} ${appendElmtClass || ""}`}
          >
            {options.map((optionItem, idx) => {
              const optionValue = optionItem.value ?? optionItem.name;
              const optionUniqueId = `${radioGroupName}_${idx}`;
              const isChecked = String(selectedNorm) === String(optionValue);

              return (
                <div
                  className={`${
                    isVertical
                      ? "sh_formcheckwrap d-flex align-items-center mb-2 ml-0 pl-0"
                      : "form-check sh_formcheckwrap form-check-inline d-inline-flex"
                  }`}
                  key={idx}
                >
                  <FormInputs
                    {...props}
                    type="Radio"
                    name={radioGroupName}
                    value={isChecked}
                    disabled={disabled || optionItem.disabled}
                    id={optionUniqueId}
                    changeHandler={(val) => {
                      if (disabled || optionItem.disabled) return; // prevent change if disabled
                      // Only set value when radio button is checked (val === true)
                      if (!val) return;

                      if (combineToKey) {
                        // ✅ combined payload mode - store single value
                        props.changeHandler(combineToKey, optionValue);
                      } else {
                        // ✅ normal mode - store selected value in the name field
                        if (name) {
                          props.changeHandler(name, optionValue);
                        } else {
                          // If no name provided, use the option name or value as the field
                          props.changeHandler(optionItem.name || optionValue, optionValue);
                        }
                      }
                    }}
                  />

                  <label
                    className={`form-check-label font-weight-bold1 pl-1 ${
                      disabled || optionItem.disabled ? "opacity-50" : ""
                    }`}
                    htmlFor={optionUniqueId}
                  >
                    {optionItem.label}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default RadioBoxGroup;
